/**
 * Versão e identificador de build injetados em tempo de build (vite.config define).
 * Atualizados a cada novo deploy.
 */

export const APP_VERSION = typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : '0.0.0';
export const BUILD_ID = typeof __BUILD_ID__ !== 'undefined' ? __BUILD_ID__ : '';
export const BUILD_TIME = typeof __BUILD_TIME__ !== 'undefined' ? __BUILD_TIME__ : '';

/** Texto exibido na área de perfil: "v0.1.0" ou "v0.1.0 (abc1234)" */
export function getBuildLabel(): string {
  if (BUILD_ID) {
    return `v${APP_VERSION} (${BUILD_ID})`;
  }
  return `v${APP_VERSION}`;
}
